import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../types'

const selectCartState = (state: RootState) => state.cart

/**
 * Selector para obter itens do carrinho
 */
export const selectCartItems = createSelector(
  [selectCartState],
  (cart) => cart.items
)

/**
 * Selector para verificar se o carrinho está aberto
 */
export const selectIsCartOpen = createSelector(
  [selectCartState],
  (cart) => cart.isOpen
)

/**
 * Selector para obter total de itens no carrinho
 */
export const selectTotalItems = createSelector(
  [selectCartItems],
  (items) => items.reduce((total, item) => total + item.quantity, 0)
)

/**
 * Selector para obter preço total do carrinho
 */
export const selectTotalPrice = createSelector(
  [selectCartItems],
  (items) => items.reduce((total, item) => {
    return total + (item.product.price * item.quantity)
  }, 0)
)

/**
 * Selector para obter subtotal
 */
export const selectSubtotal = createSelector(
  [selectCartItems],
  (items) => items.reduce((total, item) => {
    return total + (item.product.price * item.quantity)
  }, 0)
)

/**
 * Selector para preferência de devolução de sucata (Campinas). null = ainda não definido.
 */
export const selectScrapPreference = createSelector(
  [selectCartState],
  (cart) => cart.scrapPreference ?? null
)

